import { createReducer } from 'redux-starter-kit';
import { SET_FIRM_CONFIG, SET_DISCLAIMER } from './actions';
import { FirmStateType } from './types';

const INITIAL_STATE: FirmStateType = {
  displayName: '',
  riskGroup: 10,
  documentUrl: null,
  coverImageUrl: null,
  riskProfiler: 'Evalue',
  questionnaireLength: 25,
  disclaimer: null,
  defaultDisclaimer: null
};

export default createReducer(INITIAL_STATE, {
  [SET_FIRM_CONFIG]: (state, { payload }) => {
    state.displayName = payload.data.display_name;
    state.riskGroup = payload.data.risk_group;
    state.documentUrl = payload.data.document_url;
    state.coverImageUrl = payload.data.cover_image_url;
    state.riskProfiler = payload.data.risk_profiler;
    state.questionnaireLength = payload.data.questionnaire_length;
    state.disclaimer = payload.data.disclaimer;
    state.defaultDisclaimer = payload.data.default_disclaimer;
  },
  [SET_DISCLAIMER]: (state, { payload }) => {
    state.disclaimer = payload;
  }
});
